export default __webpack_public_path__ + "static/media/Map2-1.a7ea0bad.png";